function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { STORAGE_KEYS as t } from "../managers/storage-manager.js";
import ve from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as L } from "../util/date-utils.js";
import { logger as N, Guid as G, EventTypes as d } from "../../shared-lib/index.js";

var Mt = /*#__PURE__*/function () {
  function Mt(s, t, i, e) {
    _classCallCheck(this, Mt);

    this.C = s, this.As = t, this.B = i, this.Sl = e, this.C = s, this.As = t, this.B = i, this.xl = 1e3, (null == e || isNaN(e)) && (e = 1800), e < this.xl / 1e3 && (N.info("Specified session timeout of " + e + "s is too small, using the minimum session timeout of " + this.xl / 1e3 + "s instead."), e = this.xl / 1e3), this.Sl = e;
  }

  _createClass(Mt, [{
    key: "Dl",
    value: function Dl(s, t) {
      return new ve(this.As.getUserId(), d.Gl, s, t.eu, {
        d: L(s - t.Nl)
      });
    }
  }, {
    key: "Ss",
    value: function Ss() {
      var s = this.C.tu(t.iu.zl);
      return null == s ? null : s.eu;
    }
  }, {
    key: "Hl",
    value: function Hl() {
      var s = new Date().valueOf(),
          i = this.B.Bl();
      if (null == i) return !1;
      var e = this.C.ps(t.bs.Wl),
          n = null == e || s - e > 1e3 * i;
      return n && this.C.js(t.bs.Wl, s), n;
    }
  }, {
    key: "kl",
    value: function kl(s, t) {
      return null == t || null == t.ql || !(s - t.Nl < this.xl) && t.ql < s;
    }
  }, {
    key: "qo",
    value: function qo() {
      var s = new Date().valueOf(),
          i = s + 1e3 * this.Sl,
          e = this.C.tu(t.iu.zl);

      if (this.kl(s, e)) {
        var n = "Generating session start event with time " + s;

        if (null != e) {
          var _s = e.Al;
          _s - e.Nl < this.xl && (_s = e.Nl + this.xl), this.C.Il(this.Dl(_s, e)), n += " (old session ended " + _s + ")";
        }

        n += ". Will expire " + i.valueOf(), N.info(n);
        var o = new _t(G.Rt(), i);
        this.C.Il(new ve(this.As.getUserId(), d.Jl, s, o.eu)), this.C.uu(t.iu.zl, o);
        return null == this.C.ps(t.bs.Wl) && this.C.js(t.bs.Wl, s), o.eu;
      }

      if (null != e) return e.Al = s, e.ql = i, this.C.uu(t.iu.zl, e), e.eu;
    }
  }, {
    key: "Kl",
    value: function Kl() {
      var s = this.C.tu(t.iu.zl);
      null != s && (this.C.Ml(t.iu.zl), this.C.Il(this.Dl(new Date().valueOf(), s)));
    }
  }]);

  return Mt;
}();

export { Mt as default };